import React, { useState } from "react";
import { Modal, Header, Button, Form as FormUi, Table } from "semantic-ui-react";
import Axios from "axios";
import cogoToast from "cogo-toast";

const BookingImportFile = (props) => {
  const [file, setFile] = useState(0);
  const [isloading, setisloading] = useState(false);
  const [fileErrors, setfileErrors] = useState([]);

  const [importLogs, setImportLogs] = useState([]);
  const [successImportingBookings, setSuccessImportingBookings] = useState(false);


  const [fileErrorsflag, setfileErrorsFlag] = useState(false);
  const handleFile = (e) => {
    let file = e.target.files[0];
    setFile(file);
  };
  const templateDownload = () => {
      let url = `${process.env.REACT_APP_TA_API_URL}/bookings/download/import/excel`
      window.location.href = url;
  };

  let handleUpload = (e) => {
    e.preventDefault();
    setisloading(true);
    if (file === "" || file === null || file === undefined) {
      setisloading(false);
    } else if (
      file.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setisloading(false);
    } else {
      let fromData = new FormData();
      fromData.append("import_booking", file);
      fromData.append("customerNumber", localStorage.getItem("customerNumber"));
      fromData.append("userId", localStorage.getItem("userId"));
      fromData.append("customer_no", Number(localStorage.getItem("customerNumber")));
      fromData.append("user_id", Number(localStorage.getItem("userId")));
      var gett = localStorage.getItem("isloggedIn");

      //http://dev-scctgateway.elixia.tech/transporter-allocation/bookings/import?customer_no=1158&user_id=84

      var url = `${process.env.REACT_APP_TA_API_URL}/bookings/import?customer_no=${Number(localStorage.getItem("customerNumber"))}&user_id=${Number(localStorage.getItem("userId"))}`;
      Axios.post(url, fromData, {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `${gett}`,
        },
      })
        .then((response) => {
          if (response?.data?.status === 1) {
            setisloading(false);
            cogoToast.success(response.data.message);
            setTimeout(()=>{
              window.location.reload()
            },1000)
          }
          else if (response?.data?.status === 0) {
            setisloading(false);
            let messageResponseLog = [];
            let tempData = response.data.message;
            for (let index = 0; index < tempData.length; index++) {
              const element = tempData[index];
              let rowLog = element.message.toString()
              let dataRow = "Row: " + element.row + ";  " + rowLog
              messageResponseLog.push(dataRow)
            }
            setImportLogs(messageResponseLog)
            setSuccessImportingBookings(true)

            cogoToast.warn("Check logs.");
          }
        })
        .catch((err) => {
          setisloading(false);
          cogoToast.error("Error while importing bookings.");
        });
    }
  };

  const viewUploadedLogs = () => {
    props.handleLogdata(importLogs)
    props.handleImportLogOpen()
  };

  return (
    <>

      <div>
        <Modal open={props.openBox} onClose={props.handleClose} size="tiny">
          {fileErrorsflag == true ? (
            <>
              <Header>{"Import File"}</Header>
              <Modal.Content scrolling>
                <Modal.Description>
                  {/* {fileErrors} */}
                  {fileErrors.map((error, index) => (
                    <Table>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>
                            <label>Error in Row &nbsp;</label>{error.row_no}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {error.errors.map((error, index) => (
                          <Table.Row>
                            <Table.Cell>
                              <label>Error in Column - &nbsp;</label>{error.column_name}
                              {error.reasons.map((error, index) => (
                                <Table.Row>
                                  <Table.Cell>
                                    {error}
                                  </Table.Cell>
                                </Table.Row>
                              ))}
                            </Table.Cell>
                          </Table.Row>

                        ))}
                      </Table.Body>
                    </Table>
                  ))}
                </Modal.Description>
              </Modal.Content>
              <Modal.Actions>
                <Button onClick={props.handleClose} size="mini">
                  {"Cancel"}
                </Button>
              </Modal.Actions>
            </>
          ) : (
            <>
              <Header>{"Import File"}</Header>
              <Modal.Content>
                <Modal.Description>
                  <FormUi.Group inline>
                    <FormUi.Field>
                      <label className="tiny ui form p-bold-600">
                        {"Import Data Using Excel Sheet(Format- xls,xlsx)."}
                      </label>
                    </FormUi.Field>
                  </FormUi.Group>
                  <FormUi.Group inline>
                    <FormUi.Field>
                      <label className="tiny ui form p-bold-300 w3-text-grey  pt-3">
                        {"Upload File"} &nbsp;
                      </label>
                      <input
                        onChange={handleFile}
                        type="file"
                        className="w3-small"
                        id="validatedCustomFile"
                      />
                    </FormUi.Field>

                    <FormUi.Field>
                      <label className="tiny ui form pt-3">
                        <span className="p-bold-600 ">
                          {"Download Excel Template from"}{" "}
                          <span
                            className="w3-text-blue p-bold-300"
                            onClick={templateDownload}
                            style={{ cursor: "pointer" }}
                          >
                            {"Here"}
                          </span>
                        </span>
                      </label>
                    </FormUi.Field>

                    {successImportingBookings &&
                      <FormUi.Field>
                        <label className="tiny ui form pt-3">
                          <span className="p-bold-600 ">
                            {"View Uploaded Excel Logs"}{" "}
                            <span
                              className="w3-text-blue p-bold-300"
                              onClick={viewUploadedLogs}
                              style={{ cursor: "pointer" }}
                            >
                              {"Here"}
                            </span>
                          </span>
                        </label>
                      </FormUi.Field>
                    }

                  </FormUi.Group>
                </Modal.Description>
              </Modal.Content>
              <Modal.Actions>
                {isloading ? <small>Loading...</small> : ""}
                <Button onClick={props.handleClose} size="mini">
                  {"Cancel"}
                </Button>
                <Button
                  onClick={handleUpload}
                  disabled={isloading ? true : false}
                  color="blue"
                  size="mini"
                >
                  {"Upload"}
                </Button>
              </Modal.Actions>

            </>
          )}
        </Modal>
      </div>

    </>
  );
};

export default BookingImportFile;
